// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1q29D","header":"MessagesList_header__3QL0Z","chat":"MessagesList_chat__1VCHS"};